
function GenesisFiltersController() {
    //var ctrl = this;

    this.clearFilters = function (filters) {
        for (var i = 0; i < filters.length; i++) {
            var filter = filters[i];
            filter.selOption = filter.options[0];
        }
        if (this.options.onClearFilters) {
            this.options.onClearFilters(filters);
        }
        this.resetSearch();
    };

    this.selectFilterOption = function (filter, option) {
        console.log('selectFilterOption');
        filter.selOption = option;
        if (option) {
            if (this.options.onSelectFilterOption) {
                this.options.onSelectFilterOption(filter, option);
            }
        }
    };

    this.doAction = function (action) {
        if (action.onClick) {
            action.onClick(action);
        }
    };

    this.doOnChange = function (search) {
        if (this.options.search.onChange) {
            this.options.search.onChange(search);
        }
    };

    this.resetSearch = function () {
        this.options.search.searchString = '';
        if (this.options.search.onChange) {
            this.options.search.onChange(this.options.search.searchString);
        }
    };

    this.hasFilters = function (filters) {
        //var has = false;
        for (var i = 0; i < filters.length; i++) {
            var filter = filters[i];
            if (!filter.selOption.isDefault) {
                return true;
            }
        }
    };
}

seedWebApp.component('sdFilters', {
    controller: GenesisFiltersController,
    bindings: {
        options: '<',
        filters: '<'
    },
    templateUrl: '/SPA/Components/sd-filters.html'
});